import DashboardSummaryCountsWidget from '../../../../components/DashboardSummaryCountsWidget/SummaryCountWidget'
import SvgIconChannels from '../../../../assets/inlineSvg/icon-channel.svg'
import SvgIconPolicies from '../../../../assets/inlineSvg/icon-policies.svg'
import SvgIconMembers from '../../../../assets/inlineSvg/icon-members.svg'
import { RootState } from '../../../../rootReducer'
import { ACTION_TEAMS_SUMMARY, fetchTeamsSummaryData } from '../../../summary/summarySlice'
import useUrlContext from '../../../../hooks/useUrlContext'
import { GDriveSummaryQueryParams, MessagesSummary } from '../../../../services/api/apiTypes'
import { getShowLoader } from '../../../../reducers/requestReducer'
import { mockTeamsSummaryCountWidgetData } from '../../renderer/utils/widgetMockdata'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../../mainDashboardv2/constants'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import React, { useEffect } from 'react'

interface OwnProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDashboardId?: string
}

interface StateProps {
  widgetData: MessagesSummary
  policiesCount?: number
  showLoader?: boolean
}

interface DispatchProps {
  fetchTeamsSummaryData: (
    params: GDriveSummaryQueryParams & { [UNIQUE_WIDGET_INDEX]?: string }
  ) => void
}

type TeamSummaryCountComponentProps = OwnProps & StateProps & DispatchProps

const SlackSummaryCounts = (props: TeamSummaryCountComponentProps) => {
  const {
    widgetData,
    policiesCount,
    showLoader,
    useMockData = false,
    widgetDatasourceId,
    widgetDashboardId,
    fetchTeamsSummaryData
  } = props
  const { membersCount, teamsCount, channelsCount } = widgetData

  const intl = useIntl()
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId ? widgetDatasourceId : context.contextFilters.datasourceId
  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)
  const teamsCountFormatted = intl.formatNumber(teamsCount || 0, { notation: 'compact' })

  const widgetDataArr = [
    {
      icon: <SvgIconChannels />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.channels' }),
      count: channelsCount || 0,
      secondaryText: intl.formatMessage(
        { id: 'dashboard.teams.widget.secondaryText.teams' },
        { count: teamsCountFormatted }
      )
    },
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.policies' }),
      count: policiesCount || 0
    },
    {
      icon: <SvgIconMembers />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.members' }),
      count: membersCount || 0
    }
  ]

  useEffect(() => {
    if (useMockData) return
    if (datasourceId) {
      fetchTeamsSummaryData({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
    }
  }, [datasourceId, fetchTeamsSummaryData, useMockData, widgetIndex])

  return (
    <DashboardSummaryCountsWidget
      summaryItems={widgetDataArr}
      showLoader={showLoader}
      useMockData={useMockData}
    />
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  const widgetIndex = getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
  return {
    widgetData: ownProps?.useMockData
      ? mockTeamsSummaryCountWidgetData.summaryCount
      : state.summary.widgetTeamsSummaryData?.[widgetIndex] || {},
    policiesCount: ownProps?.useMockData
      ? mockTeamsSummaryCountWidgetData.policiesCount
      : state.dashboardSummaryCounts.policiesCount?.[widgetIndex],
    showLoader: getShowLoader(ACTION_TEAMS_SUMMARY)
  }
}

const mapDispatchToProps: DispatchProps = { fetchTeamsSummaryData }

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(SlackSummaryCounts)
